<template>
  <b-row
    align-v="center"
    @mouseover="setContextOnHover(contextHelpRoot+'Potential')"
    @mouseleave="setContextOnHover(contextHelpRoot+'Potential')"
  >
    <b-col class="m-0">
      <p class="label">
        {{ axis }}-axis (Potential)
      </p>
    </b-col>
    <b-col class="m-0">
      <SimpleDropdownConfiguration :controller="InputPotential" />
    </b-col>
    <b-col class="m-0">
      <SimpleDropdownConfiguration :controller="OutputPotential" />
    </b-col>
    <b-col class="m-0">
      <CheckBoxConfiguration
        :controller="Log_axis"
        :switchprop="true"
      />
    </b-col>
  </b-row>
</template>

<script>
import {comboBoxConfCtrller, checkBoxGraphConfCtrller} from '@/assets/classes/configuration.js'
import SimpleDropdownConfiguration from '../elements/SimpleDropdownConfiguration'
import CheckBoxConfiguration from '../elements/CheckBoxConfiguration'
import { TypeAxis, ConfigName } from '@/common/plotDefinitions.js'
import { mapActions } from 'vuex'

const contextHelpRoot='ReportViewer/Units/'

export default {
  name: 'PotentialConfiguration',
  components: { 
    SimpleDropdownConfiguration,
    CheckBoxConfiguration
  },
  props: {
    axis:{
      type:String,
      required:true
    },
    sectionconfig:{
      type:String,
      required: true
    }
  },
  data () {
    return {
      InputPotential: new comboBoxConfCtrller(TypeAxis.potential.inputConfig,
        [
          {text:'V',value:0},
          {text:'mV',value:-3},
          {text:'μV',value:-6},
          {text:'nV',value:-9},
          {text:'pV',value:-12}
        ],'Input Potential',0,`${contextHelpRoot}InputPotential`,true),
      OutputPotential: new comboBoxConfCtrller(TypeAxis.potential.outputConfig,
        [
          {text:'V',value:0},
          {text:'mV',value:-3},
          {text:'μV',value:-6},
          {text:'nV',value:-9},
          {text:'pV',value:-12}
        ],'Output Potential',0,`${contextHelpRoot}OutputPotential`,true),
      Log_axis: new checkBoxGraphConfCtrller(`${ConfigName.BaseAxisProperties}.LOG{0}_BOOL`,'',false,contextHelpRoot+'Log_axis'),
      elementsConfig:[],
      contextHelpRoot
    }
  },
  mounted(){
    this.elementsConfig=[
      this.InputPotential,
      this.OutputPotential,
      this.Log_axis
    ]
    this.Log_axis.formatKeyValue(this.axis)
    this.elementsConfig.forEach(conf=>conf.configCategory=this.sectionconfig)
    this.elementsConfig.forEach(conf=>conf.setParent(this))
  },
  methods:mapActions(['setContextOnHover','setConfigReportModifiedReportViewer']),
}
</script>

<style lang="scss" scoped>
.label{
  margin:0px;
  font-size: 0.8rem;
}

.header{
  font-weight: bold;
  font-size: 0.9rem;
  margin-bottom: 0.35rem;
}
::v-deep .label-input-text{
  font-size: 0.8rem;
}
</style>
